exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toast {\r\n\tposition: fixed;\r\n\tright: 50px;\r\n\tbottom: -10%;\r\n\tbackground-color: #333;\r\n\tcolor: white;\r\n\tpadding: 20px;\r\n\tfont-size: 20px;\r\n\tz-index: 1000;\r\n\tmax-width: 70%;\r\n\t\r\n\topacity: 0;\r\n\t\r\n\tanimation: fade 5s;\r\n\t\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n}\r\n\r\n.Toast.Green {\r\n\tbackground-color: #0D9191;\r\n}\r\n\r\n.Toast.Orange {\r\n\tbackground-color: #F27915;\r\n}\r\n.Toast.Red {\r\n\tbackground-color: #ac2925;\r\n}\r\n\r\n@keyframes fade {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\tbottom: -10%;\r\n\t}\r\n    5% {\r\n\t\topacity: 1;\r\n\t\tbottom: 50px;\r\n\t}\r\n\t95% {\r\n\t\topacity: 1;\r\n\t\tbottom: 50px;\r\n\t}\r\n\t100% {\r\n\t\topacity: 0;\r\n\t\tbottom: -10%;\r\n\t}\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .Toast {\r\n        margin: 0 auto;\r\n        position: fixed;\r\n        left: auto;\r\n        font-size: 11px;\r\n\r\n    }\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Toast/Toast.css
// module id = 705
// module chunks = 0